// src/layouts/ThemeProvider.js
import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import theme from '../theme/theme';
import GlobalStyles from './GlobalStyles';

const ThemeProvider = ({ children }) => (
  <StyledThemeProvider theme={theme}>
    <GlobalStyles />
    {children}
  </StyledThemeProvider>
);

export default ThemeProvider;
